import React, { useState } from 'react';
import * as yup from 'yup';
import { useFormik, FormikProvider, FieldArray } from "formik";
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';

import {
  Box,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import BootstrapDialog, { BootstrapDialogTitle } from '../../components/common/dialog/BootstrapDialog';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import NoticeFileMultiForm from '../../components/noticemng/NoticeFileMultiForm';
import NoticeForm from '../../components/noticemng/NoticeForm';
import NoticeFileListContainer from './NoticeFileListContainer';
import * as noticeApi from '../../lib/api/notice';
import * as fileApi from '../../lib/api/file';
import dayjs from 'dayjs';
import { listNotices } from '../../modules/noticeModule/notices';
import AskDialog from '../../components/common/dialog/AskDialog';

const NoticeFormContainer = ({ type, data, open, handleClose, searchData }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();


  let initialValues = {
    wrTitle:
      data && data.wrTitle !== null && data.wrTitle !== undefined
        ? data.wrTitle
        : '',
    wrContent:
      data && data.wrContent !== null && data.wrContent !== undefined
        ? data.wrContent
        : '',
    wrStartDt:
      data && data.wrStartDt !== null && data.wrStartDt !== undefined
        ? data.wrStartDt
        : '',
    wrEndDt:
      data && data.wrEndDt !== null && data.wrEndDt !== undefined
        ? data.wrEndDt
        : '',
    useYn: data && data.useYn !== undefined ? data.useYn : true,
    files: [{ fileDesc: '', file: null }]
  };

  let validationSchema = yup.object({
    wrTitle: yup.string().required('공지 제목을 입력하세요'),
    wrContent: yup.string().required('공지 내용을 입력하세요'),
    wrStartDt: yup
      .date()
      .nullable()
      .default(undefined),
    wrEndDt: yup
      .date()
      .min(yup.ref('wrStartDt'), '게시 종료일을 확인하세요')
      .when('wrStartDt', (wrStartDt, schema) => {
        if (wrStartDt)
          return schema.required('게시 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),

  });


  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      handleClose();
      setSubmitting(false);

    },
  });


  const onSave = async (values) => {
    let dataToSubmit = {
      wrTitle: values.wrTitle,
      wrContent: values.wrContent,
      wrStartDt: (values.wrStartDt) ? dayjs(values.wrStartDt).format('YYYY-MM-DD') : null,
      wrEndDt: (values.wrEndDt) ? dayjs(values.wrEndDt).format('YYYY-MM-DD') : null,
      useYn: values.useYn === true ? 'Y' : 'N',
    }

    if (type === 'add') {
      try {
        const response = await noticeApi.addNotice(
          dataToSubmit
        );
        if (response.data) {
          // console.log(values?.files.length, 'values?.files.length');
          // console.log(values.files[0].file, 'values.files[0].file');
          if (values?.files.length > 0 && values.files[0].file !== null) {
            values.files.forEach((value, index) => {

              onFileSave(value, response.data);
            })
          } else {
            dispatch(listNotices(searchData));
            handleClose();
          }

          enqueueSnackbar("공지가 추가되었습니다.", {
            variant: 'success',
          });
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

    } else {
      dataToSubmit.wrUuid = data.wrUuid;//공지 번호
      try {
        const response = await noticeApi.editNotice(
          data?.wrUuid,
          dataToSubmit
        );
        if (response.data.info) {
          if (values?.files.length > 0 && values.files[0].file !== null) {
            values.files.forEach(value => {
              onFileSave(value, response.data.info);
            })
          } else {
            dispatch(listNotices(searchData));
            handleClose();
          }

          enqueueSnackbar("공지가 수정되었습니다.", {
            variant: 'success',
          });
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

    }
  }

  const [visible, setVisible] = useState(false);

  const onDelete = () => {
    setVisible(true);
  }
  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  const onRemove = async () => {
    //console.log(techMid.rptUuid);
    try {
      const res = await noticeApi.removeNotice(data.wrUuid)

      if (res.data.result === 'success') {
        dispatch(listNotices());
        handleClose();
      }
      enqueueSnackbar('공지사항 삭제 성공', {
        variant: 'success',
      });
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response?.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  }

  const onFileSave = async (value, notice) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'notice');
    formData.append('fileAttrVal1', notice.wrUuid);
    formData.append('fileDesc', value.fileDesc);
    //console.log(formData, 'formData');

    try {
      const response = await fileApi.addFiles(formData);
      if (response.data) {

        enqueueSnackbar("공지 첨부파일이 등록되었습니다.", {
          variant: 'success',
        });
      }
      dispatch(listNotices(searchData));

    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  }




  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="md"
    >
      <BootstrapDialogTitle id="dialog-title" onClose={handleClose}>
        공지사항 {type === 'edit' ? '수정' : '추가'}
      </BootstrapDialogTitle>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <DialogContent dividers
          sx={{
            height: 400,
            overflowY: 'auto',
          }}>
          <DetailTemplate title="공지사항">
            <NoticeForm notice={data} formik={formik} />
          </DetailTemplate>

          <DetailTemplate title="첨부 파일">
            <FormikProvider value={formik}>
              <FieldArray name="files"
                render={arrayHelpers => (
                  <Box>
                    <Box>
                      {formik.values?.files.map((f, index) => {
                        return (
                          <NoticeFileMultiForm
                            key={index}
                            file={f}
                            index={index}
                            touched={formik.touched}
                            errors={formik.errors}
                            handleChange={formik.handleChange}
                            handleBlur={formik.handleBlur}
                            handleRemove={() => arrayHelpers.remove(index)} />
                        )
                      })}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 2 }}>
                      <Button sx={{ mx: 2 }} color="secondary" variant="outlined" onClick={() => arrayHelpers.push({ fileDesc: '', file: null })}>파일 추가</Button>
                    </Box>
                  </Box>
                )}
              >
              </FieldArray>
            </FormikProvider>
          </DetailTemplate>
          {type === 'edit' && (
            <DetailTemplate title="첨부 서류 리스트">
              <NoticeFileListContainer notice={data} />
            </DetailTemplate>
          )}
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Button
              type="button"
              variant="contained"
              color="error"
              onClick={onDelete}
            >
              삭제
            </Button>
          </Box>
          <Box>
            <Button
              type="submit"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              저장
            </Button>
          </Box>
        </DialogActions>
      </Box>
      <AskDialog
        visible={visible}
        title="공지사항 삭제"
        description="선택한 공지를 삭제하시겠습니까?(복구 불가)"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </BootstrapDialog>
  )
}

export default NoticeFormContainer